<template lang="html">
  <el-row :gutter="24" class="footerRight">
    <el-col :span="12" class="first">
      <el-button  class="w-100" :type="(edit) ? 'warning' : 'success'" @click="selectOption(option)"
      :icon="'el-icon-' + (edit ? 'edit' : 'check')">
        <el-divider direction="vertical"></el-divider>
        {{ (edit) ? 'Actualziar' : 'Guardar' }}
      </el-button>
    </el-col>
    <el-col :span="12" v-if="!edit">
      <el-button class="w-100" @click="selectOption('cancel')" icon="el-icon-close">
        <el-divider direction="vertical"></el-divider>
        Cancelar
      </el-button>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "FooterComponent",
  props: ["edit", "table"],
  computed: {
    option() {
      return this.edit ? "update" : "save";
    }
  },
  methods: {
    selectOption(type) {
      bus.$emit(type);
    }
  }
};
</script>

<style lang="css" scoped>
.footerRight {
  position: fixed;
  bottom: 0;
  padding: 10px 20px;
  margin-right: 0px;
  margin-left: 0px;
  border-top: solid 1px #dcdfe6;
  background-color: white;
  z-index: 3;
  width: 26.5%;
}
.first {
  border-right: solid 1px #dcdfe6;
}
</style>
